/* tslint:disable */
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import { type AddUser, AddUserFromJSON, AddUserToJSON } from "../models/AddUser";
import {
  type BaseEventState,
  BaseEventStateFromJSON,
  BaseEventStateToJSON,
} from "../models/BaseEventState";
import {
  type BulkTimeseriesRain,
  BulkTimeseriesRainFromJSON,
  BulkTimeseriesRainToJSON,
} from "../models/BulkTimeseriesRain";
import {
  type ConflictError,
  ConflictErrorFromJSON,
  ConflictErrorToJSON,
} from "../models/ConflictError";
import {
  type CopyToThreediModel,
  CopyToThreediModelFromJSON,
  CopyToThreediModelToJSON,
} from "../models/CopyToThreediModel";
import {
  type CurrentVersion,
  CurrentVersionFromJSON,
  CurrentVersionToJSON,
} from "../models/CurrentVersion";
import {
  type DeleteConflictError,
  DeleteConflictErrorFromJSON,
  DeleteConflictErrorToJSON,
} from "../models/DeleteConflictError";
import { type Download, DownloadFromJSON, DownloadToJSON } from "../models/Download";
import {
  type GroundWaterSubstanceConcentration,
  GroundWaterSubstanceConcentrationFromJSON,
  GroundWaterSubstanceConcentrationToJSON,
} from "../models/GroundWaterSubstanceConcentration";
import {
  type InitialConcentration,
  InitialConcentrationFromJSON,
  InitialConcentrationToJSON,
} from "../models/InitialConcentration";
import {
  type ObstacleEdit,
  ObstacleEditFromJSON,
  ObstacleEditToJSON,
} from "../models/ObstacleEdit";
import {
  type OneDSubstanceConcentration,
  OneDSubstanceConcentrationFromJSON,
  OneDSubstanceConcentrationToJSON,
} from "../models/OneDSubstanceConcentration";
import {
  type PaginatedBulkTimeseriesRainList,
  PaginatedBulkTimeseriesRainListFromJSON,
  PaginatedBulkTimeseriesRainListToJSON,
} from "../models/PaginatedBulkTimeseriesRainList";
import {
  type PaginatedGroundWaterSubstanceConcentrationList,
  PaginatedGroundWaterSubstanceConcentrationListFromJSON,
  PaginatedGroundWaterSubstanceConcentrationListToJSON,
} from "../models/PaginatedGroundWaterSubstanceConcentrationList";
import {
  type PaginatedInitialConcentrationList,
  PaginatedInitialConcentrationListFromJSON,
  PaginatedInitialConcentrationListToJSON,
} from "../models/PaginatedInitialConcentrationList";
import {
  type PaginatedObstacleEditList,
  PaginatedObstacleEditListFromJSON,
  PaginatedObstacleEditListToJSON,
} from "../models/PaginatedObstacleEditList";
import {
  type PaginatedOneDSubstanceConcentrationList,
  PaginatedOneDSubstanceConcentrationListFromJSON,
  PaginatedOneDSubstanceConcentrationListToJSON,
} from "../models/PaginatedOneDSubstanceConcentrationList";
import {
  type PaginatedPersonalAPIKeyList,
  PaginatedPersonalAPIKeyListFromJSON,
  PaginatedPersonalAPIKeyListToJSON,
} from "../models/PaginatedPersonalAPIKeyList";
import {
  type PaginatedSubstanceList,
  PaginatedSubstanceListFromJSON,
  PaginatedSubstanceListToJSON,
} from "../models/PaginatedSubstanceList";
import {
  type PaginatedTwoDSubstanceConcentrationList,
  PaginatedTwoDSubstanceConcentrationListFromJSON,
  PaginatedTwoDSubstanceConcentrationListToJSON,
} from "../models/PaginatedTwoDSubstanceConcentrationList";
import {
  type PatchedBulkTimeseriesRain,
  PatchedBulkTimeseriesRainFromJSON,
  PatchedBulkTimeseriesRainToJSON,
} from "../models/PatchedBulkTimeseriesRain";
import {
  type PatchedGroundWaterSubstanceConcentration,
  PatchedGroundWaterSubstanceConcentrationFromJSON,
  PatchedGroundWaterSubstanceConcentrationToJSON,
} from "../models/PatchedGroundWaterSubstanceConcentration";
import {
  type PatchedInitialConcentration,
  PatchedInitialConcentrationFromJSON,
  PatchedInitialConcentrationToJSON,
} from "../models/PatchedInitialConcentration";
import {
  type PatchedObstacleEdit,
  PatchedObstacleEditFromJSON,
  PatchedObstacleEditToJSON,
} from "../models/PatchedObstacleEdit";
import {
  type PatchedOneDSubstanceConcentration,
  PatchedOneDSubstanceConcentrationFromJSON,
  PatchedOneDSubstanceConcentrationToJSON,
} from "../models/PatchedOneDSubstanceConcentration";
import {
  type PatchedResource,
  PatchedResourceFromJSON,
  PatchedResourceToJSON,
} from "../models/PatchedResource";
import {
  type PatchedSubstance,
  PatchedSubstanceFromJSON,
  PatchedSubstanceToJSON,
} from "../models/PatchedSubstance";
import {
  type PatchedTwoDSubstanceConcentration,
  PatchedTwoDSubstanceConcentrationFromJSON,
  PatchedTwoDSubstanceConcentrationToJSON,
} from "../models/PatchedTwoDSubstanceConcentration";
import {
  type PersonalAPIKey,
  PersonalAPIKeyFromJSON,
  PersonalAPIKeyToJSON,
} from "../models/PersonalAPIKey";
import {
  type PersonalAPIKeyWithSecret,
  PersonalAPIKeyWithSecretFromJSON,
  PersonalAPIKeyWithSecretToJSON,
} from "../models/PersonalAPIKeyWithSecret";
import {
  type RasterEditUrls,
  RasterEditUrlsFromJSON,
  RasterEditUrlsToJSON,
} from "../models/RasterEditUrls";
import { type Status, StatusFromJSON, StatusToJSON } from "../models/Status";
import { type Substance, SubstanceFromJSON, SubstanceToJSON } from "../models/Substance";
import { type Template, TemplateFromJSON, TemplateToJSON } from "../models/Template";
import {
  type TwoDSubstanceConcentration,
  TwoDSubstanceConcentrationFromJSON,
  TwoDSubstanceConcentrationToJSON,
} from "../models/TwoDSubstanceConcentration";
import { type Upload, UploadFromJSON, UploadToJSON } from "../models/Upload";
import {
  type UploadBulkTimeseriesRainFile,
  UploadBulkTimeseriesRainFileFromJSON,
  UploadBulkTimeseriesRainFileToJSON,
} from "../models/UploadBulkTimeseriesRainFile";

export interface AuthUsersCreateRequest {
  /**
   *
   */
  data: Omit<AddUser, "userId">;
}

export interface AuthUsersPersonalapikeysCreateRequest {
  /**
   *
   */
  userPk: number;
  /**
   *
   */
  data: Omit<PersonalAPIKey, "prefix" | "created" | "lastUsed">;
}

export interface AuthUsersPersonalapikeysDeleteRequest {
  /**
   *
   */
  prefix: string;
  /**
   *
   */
  userPk: number;
}

export interface AuthUsersPersonalapikeysListRequest {
  /**
   *
   */
  userPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface AuthUsersPersonalapikeysReadRequest {
  /**
   *
   */
  prefix: string;
  /**
   *
   */
  userPk: number;
}

export interface AuthUsersPersonalapikeysRevokeRequest {
  /**
   *
   */
  prefix: string;
  /**
   *
   */
  userPk: number;
}

export interface PersonalapikeysCreateRequest {
  /**
   *
   */
  data: Omit<PersonalAPIKey, "prefix" | "created" | "lastUsed">;
}

export interface PersonalapikeysDeleteRequest {
  /**
   *
   */
  prefix: string;
}

export interface PersonalapikeysListRequest {
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface PersonalapikeysReadRequest {
  /**
   *
   */
  prefix: string;
}

export interface PersonalapikeysRevokeRequest {
  /**
   *
   */
  prefix: string;
}

export interface SimulationTemplatesCopyToThreedimodelRequest {
  /**
   *
   */
  id: number;
  /**
   *
   */
  data: CopyToThreediModel;
}

export interface SimulationsEventsObstacleEditsCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<ObstacleEdit, "url" | "simulation" | "state" | "stateDetail" | "uid" | "id">;
}

export interface SimulationsEventsObstacleEditsDeleteRequest {
  /**
   * A unique integer value identifying this obstacle edit.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsObstacleEditsListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SimulationsEventsObstacleEditsPartialUpdateRequest {
  /**
   * A unique integer value identifying this obstacle edit.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<PatchedObstacleEdit, "url" | "simulation" | "state" | "stateDetail" | "uid" | "id">;
}

export interface SimulationsEventsObstacleEditsProcessedRequest {
  /**
   * A unique integer value identifying this obstacle edit.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: BaseEventState;
}

export interface SimulationsEventsObstacleEditsReadRequest {
  /**
   * A unique integer value identifying this obstacle edit.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsObstacleEditsRegisterRelatedRastersRequest {
  /**
   * A unique integer value identifying this obstacle edit.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsObstacleEditsUpdateRequest {
  /**
   * A unique integer value identifying this obstacle edit.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<ObstacleEdit, "url" | "simulation" | "state" | "stateDetail" | "uid" | "id">;
}

export interface SimulationsEventsRainTimeseriesFileCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<UploadBulkTimeseriesRainFile, "putUrl" | "status">;
}

export interface SimulationsEventsRainTimeseriesFileDeleteRequest {
  /**
   * A unique integer value identifying this bulk timeseries rain.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsRainTimeseriesFileDownloadRequest {
  /**
   * A unique integer value identifying this bulk timeseries rain.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsRainTimeseriesFileListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SimulationsEventsRainTimeseriesFilePartialUpdateRequest {
  /**
   * A unique integer value identifying this bulk timeseries rain.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<
    PatchedBulkTimeseriesRain,
    "url" | "id" | "uid" | "simulation" | "state" | "stateDetail"
  >;
}

export interface SimulationsEventsRainTimeseriesFileProcessedRequest {
  /**
   * A unique integer value identifying this bulk timeseries rain.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: BaseEventState;
}

export interface SimulationsEventsRainTimeseriesFileReadRequest {
  /**
   * A unique integer value identifying this bulk timeseries rain.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsEventsRainTimeseriesFileUpdateRequest {
  /**
   * A unique integer value identifying this bulk timeseries rain.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<BulkTimeseriesRain, "url" | "id" | "uid" | "simulation" | "state" | "stateDetail">;
}

export interface SimulationsInitial1dSubstanceConcentrationsCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<
    OneDSubstanceConcentration,
    "url" | "simulation" | "substanceId" | "substanceName" | "initialConcentrationId" | "uid" | "id"
  >;
}

export interface SimulationsInitial1dSubstanceConcentrationsDeleteRequest {
  /**
   * A unique integer value identifying this one d substance concentration.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsInitial1dSubstanceConcentrationsListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SimulationsInitial1dSubstanceConcentrationsPartialUpdateRequest {
  /**
   * A unique integer value identifying this one d substance concentration.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<
    PatchedOneDSubstanceConcentration,
    "url" | "simulation" | "substanceId" | "substanceName" | "initialConcentrationId" | "uid" | "id"
  >;
}

export interface SimulationsInitial1dSubstanceConcentrationsReadRequest {
  /**
   * A unique integer value identifying this one d substance concentration.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsInitial1dSubstanceConcentrationsUpdateRequest {
  /**
   * A unique integer value identifying this one d substance concentration.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<
    OneDSubstanceConcentration,
    "url" | "simulation" | "substanceId" | "substanceName" | "initialConcentrationId" | "uid" | "id"
  >;
}

export interface SimulationsInitial2dSubstanceConcentrationsCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<
    TwoDSubstanceConcentration,
    "url" | "simulation" | "substanceId" | "substanceName" | "initialConcentrationId" | "uid" | "id"
  >;
}

export interface SimulationsInitial2dSubstanceConcentrationsDeleteRequest {
  /**
   * A unique integer value identifying this two d substance concentration.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsInitial2dSubstanceConcentrationsListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SimulationsInitial2dSubstanceConcentrationsPartialUpdateRequest {
  /**
   * A unique integer value identifying this two d substance concentration.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<
    PatchedTwoDSubstanceConcentration,
    "url" | "simulation" | "substanceId" | "substanceName" | "initialConcentrationId" | "uid" | "id"
  >;
}

export interface SimulationsInitial2dSubstanceConcentrationsReadRequest {
  /**
   * A unique integer value identifying this two d substance concentration.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsInitial2dSubstanceConcentrationsUpdateRequest {
  /**
   * A unique integer value identifying this two d substance concentration.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<
    TwoDSubstanceConcentration,
    "url" | "simulation" | "substanceId" | "substanceName" | "initialConcentrationId" | "uid" | "id"
  >;
}

export interface SimulationsInitialGroundwaterSubstanceConcentrationsCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<
    GroundWaterSubstanceConcentration,
    "url" | "simulation" | "substanceId" | "substanceName" | "initialConcentrationId" | "uid" | "id"
  >;
}

export interface SimulationsInitialGroundwaterSubstanceConcentrationsDeleteRequest {
  /**
   * A unique integer value identifying this ground water substance concentration.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsInitialGroundwaterSubstanceConcentrationsListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SimulationsInitialGroundwaterSubstanceConcentrationsPartialUpdateRequest {
  /**
   * A unique integer value identifying this ground water substance concentration.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<
    PatchedGroundWaterSubstanceConcentration,
    "url" | "simulation" | "substanceId" | "substanceName" | "initialConcentrationId" | "uid" | "id"
  >;
}

export interface SimulationsInitialGroundwaterSubstanceConcentrationsReadRequest {
  /**
   * A unique integer value identifying this ground water substance concentration.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsInitialGroundwaterSubstanceConcentrationsUpdateRequest {
  /**
   * A unique integer value identifying this ground water substance concentration.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<
    GroundWaterSubstanceConcentration,
    "url" | "simulation" | "substanceId" | "substanceName" | "initialConcentrationId" | "uid" | "id"
  >;
}

export interface SimulationsSubstancesCreateRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<Substance, "url" | "id" | "uid">;
}

export interface SimulationsSubstancesDeleteRequest {
  /**
   * A unique integer value identifying this substance.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsSubstancesListRequest {
  /**
   *
   */
  simulationPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface SimulationsSubstancesPartialUpdateRequest {
  /**
   * A unique integer value identifying this substance.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<PatchedSubstance, "url" | "id" | "uid">;
}

export interface SimulationsSubstancesReadRequest {
  /**
   * A unique integer value identifying this substance.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
}

export interface SimulationsSubstancesUpdateRequest {
  /**
   * A unique integer value identifying this substance.
   */
  id: number;
  /**
   *
   */
  simulationPk: number;
  /**
   *
   */
  data: Omit<Substance, "url" | "id" | "uid">;
}

export interface ThreedimodelsInitialConcentrationsCreateRequest {
  /**
   *
   */
  threedimodelPk: number;
  /**
   *
   */
  data: Omit<
    InitialConcentration,
    "url" | "threedimodel" | "file" | "state" | "stateDetail" | "id" | "sourceRasterId"
  >;
}

export interface ThreedimodelsInitialConcentrationsDeleteRequest {
  /**
   * A unique integer value identifying this initial concentration.
   */
  id: number;
  /**
   *
   */
  threedimodelPk: number;
}

export interface ThreedimodelsInitialConcentrationsDownloadRequest {
  /**
   * A unique integer value identifying this initial concentration.
   */
  id: number;
  /**
   *
   */
  threedimodelPk: number;
}

export interface ThreedimodelsInitialConcentrationsListRequest {
  /**
   *
   */
  threedimodelPk: number;
  /**
   * Number of results to return per page.
   */
  limit?: number;
  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export interface ThreedimodelsInitialConcentrationsPartialUpdateRequest {
  /**
   * A unique integer value identifying this initial concentration.
   */
  id: number;
  /**
   *
   */
  threedimodelPk: number;
  /**
   *
   */
  data: Omit<
    PatchedInitialConcentration,
    "url" | "threedimodel" | "file" | "state" | "stateDetail" | "id" | "sourceRasterId"
  >;
}

export interface ThreedimodelsInitialConcentrationsProcessedRequest {
  /**
   * A unique integer value identifying this initial concentration.
   */
  id: number;
  /**
   *
   */
  threedimodelPk: number;
  /**
   *
   */
  data: BaseEventState;
}

export interface ThreedimodelsInitialConcentrationsReadRequest {
  /**
   * A unique integer value identifying this initial concentration.
   */
  id: number;
  /**
   *
   */
  threedimodelPk: number;
}

export interface ThreedimodelsInitialConcentrationsUpdateRequest {
  /**
   * A unique integer value identifying this initial concentration.
   */
  id: number;
  /**
   *
   */
  threedimodelPk: number;
  /**
   *
   */
  data: Omit<
    InitialConcentration,
    "url" | "threedimodel" | "file" | "state" | "stateDetail" | "id" | "sourceRasterId"
  >;
}

export interface ThreedimodelsInitialConcentrationsUploadRequest {
  /**
   * A unique integer value identifying this initial concentration.
   */
  id: number;
  /**
   *
   */
  threedimodelPk: number;
  /**
   *
   */
  data: Omit<Upload, "putUrl" | "status">;
}

/**
 *
 */
export class V3BetaApi extends runtime.BaseAPI {
  /**
   * Creates request options for authUsersCreate without sending the request
   */
  async authUsersCreateRequestOpts(
    requestParameters: AuthUsersCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling authUsersCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/auth/users/`;

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: AddUserToJSON(requestParameters["data"]),
    };
  }

  /**
   */
  async authUsersCreateRaw(
    requestParameters: AuthUsersCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<AddUser>> {
    const requestOptions = await this.authUsersCreateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => AddUserFromJSON(jsonValue));
  }

  /**
   */
  async authUsersCreate(
    requestParameters: AuthUsersCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<AddUser> {
    const response = await this.authUsersCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for authUsersPersonalapikeysCreate without sending the request
   */
  async authUsersPersonalapikeysCreateRequestOpts(
    requestParameters: AuthUsersPersonalapikeysCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["userPk"] == null) {
      throw new runtime.RequiredError(
        "userPk",
        'Required parameter "userPk" was null or undefined when calling authUsersPersonalapikeysCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling authUsersPersonalapikeysCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/auth/users/{user_pk}/personalapikeys/`;
    urlPath = urlPath.replace("{user_pk}", encodeURIComponent(String(requestParameters["userPk"])));

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: PersonalAPIKeyToJSON(requestParameters["data"]),
    };
  }

  /**
   * Personal API keys are used for authentication without password.
   */
  async authUsersPersonalapikeysCreateRaw(
    requestParameters: AuthUsersPersonalapikeysCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PersonalAPIKeyWithSecret>> {
    const requestOptions = await this.authUsersPersonalapikeysCreateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PersonalAPIKeyWithSecretFromJSON(jsonValue)
    );
  }

  /**
   * Personal API keys are used for authentication without password.
   */
  async authUsersPersonalapikeysCreate(
    requestParameters: AuthUsersPersonalapikeysCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PersonalAPIKeyWithSecret> {
    const response = await this.authUsersPersonalapikeysCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for authUsersPersonalapikeysDelete without sending the request
   */
  async authUsersPersonalapikeysDeleteRequestOpts(
    requestParameters: AuthUsersPersonalapikeysDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["prefix"] == null) {
      throw new runtime.RequiredError(
        "prefix",
        'Required parameter "prefix" was null or undefined when calling authUsersPersonalapikeysDelete().'
      );
    }

    if (requestParameters["userPk"] == null) {
      throw new runtime.RequiredError(
        "userPk",
        'Required parameter "userPk" was null or undefined when calling authUsersPersonalapikeysDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/auth/users/{user_pk}/personalapikeys/{prefix}/`;
    urlPath = urlPath.replace("{prefix}", encodeURIComponent(String(requestParameters["prefix"])));
    urlPath = urlPath.replace("{user_pk}", encodeURIComponent(String(requestParameters["userPk"])));

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Personal API keys are used for authentication without password.
   */
  async authUsersPersonalapikeysDeleteRaw(
    requestParameters: AuthUsersPersonalapikeysDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.authUsersPersonalapikeysDeleteRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Personal API keys are used for authentication without password.
   */
  async authUsersPersonalapikeysDelete(
    requestParameters: AuthUsersPersonalapikeysDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.authUsersPersonalapikeysDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for authUsersPersonalapikeysList without sending the request
   */
  async authUsersPersonalapikeysListRequestOpts(
    requestParameters: AuthUsersPersonalapikeysListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["userPk"] == null) {
      throw new runtime.RequiredError(
        "userPk",
        'Required parameter "userPk" was null or undefined when calling authUsersPersonalapikeysList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/auth/users/{user_pk}/personalapikeys/`;
    urlPath = urlPath.replace("{user_pk}", encodeURIComponent(String(requestParameters["userPk"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Personal API keys are used for authentication without password.
   */
  async authUsersPersonalapikeysListRaw(
    requestParameters: AuthUsersPersonalapikeysListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedPersonalAPIKeyList>> {
    const requestOptions = await this.authUsersPersonalapikeysListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedPersonalAPIKeyListFromJSON(jsonValue)
    );
  }

  /**
   * Personal API keys are used for authentication without password.
   */
  async authUsersPersonalapikeysList(
    requestParameters: AuthUsersPersonalapikeysListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedPersonalAPIKeyList> {
    const response = await this.authUsersPersonalapikeysListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for authUsersPersonalapikeysRead without sending the request
   */
  async authUsersPersonalapikeysReadRequestOpts(
    requestParameters: AuthUsersPersonalapikeysReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["prefix"] == null) {
      throw new runtime.RequiredError(
        "prefix",
        'Required parameter "prefix" was null or undefined when calling authUsersPersonalapikeysRead().'
      );
    }

    if (requestParameters["userPk"] == null) {
      throw new runtime.RequiredError(
        "userPk",
        'Required parameter "userPk" was null or undefined when calling authUsersPersonalapikeysRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/auth/users/{user_pk}/personalapikeys/{prefix}/`;
    urlPath = urlPath.replace("{prefix}", encodeURIComponent(String(requestParameters["prefix"])));
    urlPath = urlPath.replace("{user_pk}", encodeURIComponent(String(requestParameters["userPk"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Personal API keys are used for authentication without password.
   */
  async authUsersPersonalapikeysReadRaw(
    requestParameters: AuthUsersPersonalapikeysReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PersonalAPIKey>> {
    const requestOptions = await this.authUsersPersonalapikeysReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => PersonalAPIKeyFromJSON(jsonValue));
  }

  /**
   * Personal API keys are used for authentication without password.
   */
  async authUsersPersonalapikeysRead(
    requestParameters: AuthUsersPersonalapikeysReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PersonalAPIKey> {
    const response = await this.authUsersPersonalapikeysReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for authUsersPersonalapikeysRevoke without sending the request
   */
  async authUsersPersonalapikeysRevokeRequestOpts(
    requestParameters: AuthUsersPersonalapikeysRevokeRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["prefix"] == null) {
      throw new runtime.RequiredError(
        "prefix",
        'Required parameter "prefix" was null or undefined when calling authUsersPersonalapikeysRevoke().'
      );
    }

    if (requestParameters["userPk"] == null) {
      throw new runtime.RequiredError(
        "userPk",
        'Required parameter "userPk" was null or undefined when calling authUsersPersonalapikeysRevoke().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/auth/users/{user_pk}/personalapikeys/{prefix}/revoke/`;
    urlPath = urlPath.replace("{prefix}", encodeURIComponent(String(requestParameters["prefix"])));
    urlPath = urlPath.replace("{user_pk}", encodeURIComponent(String(requestParameters["userPk"])));

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Revoke an API key and return the status.
   */
  async authUsersPersonalapikeysRevokeRaw(
    requestParameters: AuthUsersPersonalapikeysRevokeRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PersonalAPIKey>> {
    const requestOptions = await this.authUsersPersonalapikeysRevokeRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => PersonalAPIKeyFromJSON(jsonValue));
  }

  /**
   * Revoke an API key and return the status.
   */
  async authUsersPersonalapikeysRevoke(
    requestParameters: AuthUsersPersonalapikeysRevokeRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PersonalAPIKey> {
    const response = await this.authUsersPersonalapikeysRevokeRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for personalapikeysCreate without sending the request
   */
  async personalapikeysCreateRequestOpts(
    requestParameters: PersonalapikeysCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling personalapikeysCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/personalapikeys/`;

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: PersonalAPIKeyToJSON(requestParameters["data"]),
    };
  }

  /**
   * Personal API keys are used for authentication without password.
   */
  async personalapikeysCreateRaw(
    requestParameters: PersonalapikeysCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PersonalAPIKeyWithSecret>> {
    const requestOptions = await this.personalapikeysCreateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PersonalAPIKeyWithSecretFromJSON(jsonValue)
    );
  }

  /**
   * Personal API keys are used for authentication without password.
   */
  async personalapikeysCreate(
    requestParameters: PersonalapikeysCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PersonalAPIKeyWithSecret> {
    const response = await this.personalapikeysCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for personalapikeysDelete without sending the request
   */
  async personalapikeysDeleteRequestOpts(
    requestParameters: PersonalapikeysDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["prefix"] == null) {
      throw new runtime.RequiredError(
        "prefix",
        'Required parameter "prefix" was null or undefined when calling personalapikeysDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/personalapikeys/{prefix}/`;
    urlPath = urlPath.replace("{prefix}", encodeURIComponent(String(requestParameters["prefix"])));

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Personal API keys are used for authentication without password.
   */
  async personalapikeysDeleteRaw(
    requestParameters: PersonalapikeysDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.personalapikeysDeleteRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Personal API keys are used for authentication without password.
   */
  async personalapikeysDelete(
    requestParameters: PersonalapikeysDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.personalapikeysDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for personalapikeysList without sending the request
   */
  async personalapikeysListRequestOpts(
    requestParameters: PersonalapikeysListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/personalapikeys/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Personal API keys are used for authentication without password.
   */
  async personalapikeysListRaw(
    requestParameters: PersonalapikeysListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedPersonalAPIKeyList>> {
    const requestOptions = await this.personalapikeysListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedPersonalAPIKeyListFromJSON(jsonValue)
    );
  }

  /**
   * Personal API keys are used for authentication without password.
   */
  async personalapikeysList(
    requestParameters: PersonalapikeysListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedPersonalAPIKeyList> {
    const response = await this.personalapikeysListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for personalapikeysRead without sending the request
   */
  async personalapikeysReadRequestOpts(
    requestParameters: PersonalapikeysReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["prefix"] == null) {
      throw new runtime.RequiredError(
        "prefix",
        'Required parameter "prefix" was null or undefined when calling personalapikeysRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/personalapikeys/{prefix}/`;
    urlPath = urlPath.replace("{prefix}", encodeURIComponent(String(requestParameters["prefix"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Personal API keys are used for authentication without password.
   */
  async personalapikeysReadRaw(
    requestParameters: PersonalapikeysReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PersonalAPIKey>> {
    const requestOptions = await this.personalapikeysReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => PersonalAPIKeyFromJSON(jsonValue));
  }

  /**
   * Personal API keys are used for authentication without password.
   */
  async personalapikeysRead(
    requestParameters: PersonalapikeysReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PersonalAPIKey> {
    const response = await this.personalapikeysReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for personalapikeysRevoke without sending the request
   */
  async personalapikeysRevokeRequestOpts(
    requestParameters: PersonalapikeysRevokeRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["prefix"] == null) {
      throw new runtime.RequiredError(
        "prefix",
        'Required parameter "prefix" was null or undefined when calling personalapikeysRevoke().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/personalapikeys/{prefix}/revoke/`;
    urlPath = urlPath.replace("{prefix}", encodeURIComponent(String(requestParameters["prefix"])));

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Revoke an API key and return the status.
   */
  async personalapikeysRevokeRaw(
    requestParameters: PersonalapikeysRevokeRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PersonalAPIKey>> {
    const requestOptions = await this.personalapikeysRevokeRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => PersonalAPIKeyFromJSON(jsonValue));
  }

  /**
   * Revoke an API key and return the status.
   */
  async personalapikeysRevoke(
    requestParameters: PersonalapikeysRevokeRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PersonalAPIKey> {
    const response = await this.personalapikeysRevokeRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for simulationTemplatesCopyToThreedimodel without sending the request
   */
  async simulationTemplatesCopyToThreedimodelRequestOpts(
    requestParameters: SimulationTemplatesCopyToThreedimodelRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationTemplatesCopyToThreedimodel().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationTemplatesCopyToThreedimodel().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/simulation-templates/{id}/copy-to-threedimodel/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: CopyToThreediModelToJSON(requestParameters["data"]),
    };
  }

  /**
   * Copy simulation template to a threedimodel.  {     \"threedimodel\": ThreediModel id     \"name\": name for the new template     \"tags\": extra tags, added to existing simulation template tags     \"clone_events\": clone events like rain/sources & sinks etc     \"clone_initials\": clone initial waterlevels & concentrations     \"clone_settings\": clone simulation settings, like physical settings etc }
   */
  async simulationTemplatesCopyToThreedimodelRaw(
    requestParameters: SimulationTemplatesCopyToThreedimodelRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Template>> {
    const requestOptions = await this.simulationTemplatesCopyToThreedimodelRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => TemplateFromJSON(jsonValue));
  }

  /**
   * Copy simulation template to a threedimodel.  {     \"threedimodel\": ThreediModel id     \"name\": name for the new template     \"tags\": extra tags, added to existing simulation template tags     \"clone_events\": clone events like rain/sources & sinks etc     \"clone_initials\": clone initial waterlevels & concentrations     \"clone_settings\": clone simulation settings, like physical settings etc }
   */
  async simulationTemplatesCopyToThreedimodel(
    requestParameters: SimulationTemplatesCopyToThreedimodelRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Template> {
    const response = await this.simulationTemplatesCopyToThreedimodelRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsObstacleEditsCreate without sending the request
   */
  async simulationsEventsObstacleEditsCreateRequestOpts(
    requestParameters: SimulationsEventsObstacleEditsCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsObstacleEditsCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsObstacleEditsCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/simulations/{simulation_pk}/events/obstacle-edits/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: ObstacleEditToJSON(requestParameters["data"]),
    };
  }

  /**
   * Create an obstacle edit
   */
  async simulationsEventsObstacleEditsCreateRaw(
    requestParameters: SimulationsEventsObstacleEditsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ObstacleEdit>> {
    const requestOptions = await this.simulationsEventsObstacleEditsCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => ObstacleEditFromJSON(jsonValue));
  }

  /**
   * Create an obstacle edit
   */
  async simulationsEventsObstacleEditsCreate(
    requestParameters: SimulationsEventsObstacleEditsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ObstacleEdit> {
    const response = await this.simulationsEventsObstacleEditsCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsObstacleEditsDelete without sending the request
   */
  async simulationsEventsObstacleEditsDeleteRequestOpts(
    requestParameters: SimulationsEventsObstacleEditsDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsObstacleEditsDelete().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsObstacleEditsDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/simulations/{simulation_pk}/events/obstacle-edits/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsObstacleEditsDeleteRaw(
    requestParameters: SimulationsEventsObstacleEditsDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsEventsObstacleEditsDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsObstacleEditsDelete(
    requestParameters: SimulationsEventsObstacleEditsDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsEventsObstacleEditsDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsEventsObstacleEditsList without sending the request
   */
  async simulationsEventsObstacleEditsListRequestOpts(
    requestParameters: SimulationsEventsObstacleEditsListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsObstacleEditsList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/simulations/{simulation_pk}/events/obstacle-edits/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing obstacle edits
   */
  async simulationsEventsObstacleEditsListRaw(
    requestParameters: SimulationsEventsObstacleEditsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedObstacleEditList>> {
    const requestOptions = await this.simulationsEventsObstacleEditsListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedObstacleEditListFromJSON(jsonValue)
    );
  }

  /**
   * A simple ViewSet for viewing obstacle edits
   */
  async simulationsEventsObstacleEditsList(
    requestParameters: SimulationsEventsObstacleEditsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedObstacleEditList> {
    const response = await this.simulationsEventsObstacleEditsListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsObstacleEditsPartialUpdate without sending the request
   */
  async simulationsEventsObstacleEditsPartialUpdateRequestOpts(
    requestParameters: SimulationsEventsObstacleEditsPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsObstacleEditsPartialUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsObstacleEditsPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsObstacleEditsPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/simulations/{simulation_pk}/events/obstacle-edits/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedObstacleEditToJSON(requestParameters["data"]),
    };
  }

  /**
   * when the simulation has started only the duration parameter might be patched
   */
  async simulationsEventsObstacleEditsPartialUpdateRaw(
    requestParameters: SimulationsEventsObstacleEditsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PatchedResource>> {
    const requestOptions = await this.simulationsEventsObstacleEditsPartialUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => PatchedResourceFromJSON(jsonValue));
  }

  /**
   * when the simulation has started only the duration parameter might be patched
   */
  async simulationsEventsObstacleEditsPartialUpdate(
    requestParameters: SimulationsEventsObstacleEditsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PatchedResource> {
    const response = await this.simulationsEventsObstacleEditsPartialUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsObstacleEditsProcessed without sending the request
   */
  async simulationsEventsObstacleEditsProcessedRequestOpts(
    requestParameters: SimulationsEventsObstacleEditsProcessedRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsObstacleEditsProcessed().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsObstacleEditsProcessed().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsObstacleEditsProcessed().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/simulations/{simulation_pk}/events/obstacle-edits/{id}/processed/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: BaseEventStateToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing obstacle edits
   */
  async simulationsEventsObstacleEditsProcessedRaw(
    requestParameters: SimulationsEventsObstacleEditsProcessedRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsEventsObstacleEditsProcessedRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * A simple ViewSet for viewing obstacle edits
   */
  async simulationsEventsObstacleEditsProcessed(
    requestParameters: SimulationsEventsObstacleEditsProcessedRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsEventsObstacleEditsProcessedRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsEventsObstacleEditsRead without sending the request
   */
  async simulationsEventsObstacleEditsReadRequestOpts(
    requestParameters: SimulationsEventsObstacleEditsReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsObstacleEditsRead().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsObstacleEditsRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/simulations/{simulation_pk}/events/obstacle-edits/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * A simple ViewSet for viewing obstacle edits
   */
  async simulationsEventsObstacleEditsReadRaw(
    requestParameters: SimulationsEventsObstacleEditsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ObstacleEdit>> {
    const requestOptions = await this.simulationsEventsObstacleEditsReadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => ObstacleEditFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing obstacle edits
   */
  async simulationsEventsObstacleEditsRead(
    requestParameters: SimulationsEventsObstacleEditsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ObstacleEdit> {
    const response = await this.simulationsEventsObstacleEditsReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsObstacleEditsRegisterRelatedRasters without sending the request
   */
  async simulationsEventsObstacleEditsRegisterRelatedRastersRequestOpts(
    requestParameters: SimulationsEventsObstacleEditsRegisterRelatedRastersRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsObstacleEditsRegisterRelatedRasters().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsObstacleEditsRegisterRelatedRasters().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/simulations/{simulation_pk}/events/obstacle-edits/{id}/register_related_rasters/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Register all related rasters in the results-api and return read_bbox urls of the registered rasters  Skips registering of related rasters when the simulation is not in the state \'starting\' or \'initialized\'. In this case the urls will be empty
   */
  async simulationsEventsObstacleEditsRegisterRelatedRastersRaw(
    requestParameters: SimulationsEventsObstacleEditsRegisterRelatedRastersRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Array<RasterEditUrls>>> {
    const requestOptions =
      await this.simulationsEventsObstacleEditsRegisterRelatedRastersRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(RasterEditUrlsFromJSON)
    );
  }

  /**
   * Register all related rasters in the results-api and return read_bbox urls of the registered rasters  Skips registering of related rasters when the simulation is not in the state \'starting\' or \'initialized\'. In this case the urls will be empty
   */
  async simulationsEventsObstacleEditsRegisterRelatedRasters(
    requestParameters: SimulationsEventsObstacleEditsRegisterRelatedRastersRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Array<RasterEditUrls>> {
    const response = await this.simulationsEventsObstacleEditsRegisterRelatedRastersRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsObstacleEditsUpdate without sending the request
   */
  async simulationsEventsObstacleEditsUpdateRequestOpts(
    requestParameters: SimulationsEventsObstacleEditsUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsObstacleEditsUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsObstacleEditsUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsObstacleEditsUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/simulations/{simulation_pk}/events/obstacle-edits/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: ObstacleEditToJSON(requestParameters["data"]),
    };
  }

  /**
   * A simple ViewSet for viewing obstacle edits
   */
  async simulationsEventsObstacleEditsUpdateRaw(
    requestParameters: SimulationsEventsObstacleEditsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ObstacleEdit>> {
    const requestOptions = await this.simulationsEventsObstacleEditsUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => ObstacleEditFromJSON(jsonValue));
  }

  /**
   * A simple ViewSet for viewing obstacle edits
   */
  async simulationsEventsObstacleEditsUpdate(
    requestParameters: SimulationsEventsObstacleEditsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ObstacleEdit> {
    const response = await this.simulationsEventsObstacleEditsUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsRainTimeseriesFileCreate without sending the request
   */
  async simulationsEventsRainTimeseriesFileCreateRequestOpts(
    requestParameters: SimulationsEventsRainTimeseriesFileCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainTimeseriesFileCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsRainTimeseriesFileCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/simulations/{simulation_pk}/events/rain/timeseries/file/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: UploadBulkTimeseriesRainFileToJSON(requestParameters["data"]),
    };
  }

  /**
   * Endpoint for uploading a file with one or more timeseries rain events.  The format of the filename should be `<filename>.json`, e.g. `timeseries_rain.json`  Every leading and trailing spaces will be removed. Other spaces are converted to underscores and anything that is not an alphanumeric, dash, underscore, or dot will be removed as well.  The response provides a put_url which allows you to upload a file containing the rain events. These events should either be a constant- or a timeseries-rain, or a combination of both. See their respective endpoints for the required fields.  The uploaded file should be a JSON-file containing an array of rain events. Example of the content of such a file: ``` [   {     \"offset\": 100,     \"value\": 0.05,     \"duration\": 300,     \"units\": \"m3/s\",   },   {     \"offset\": 180,     \"interpolate\": false,     \"values\": [       [0.0, 0.0002],       [900.0, 0.0],       [1200.0, 0.0001],       [1620.0, 0.0]     ],     \"units\": \"m3/s\",   },   {     \"offset\": 200,     \"values\": [[0, 0.05], [3600, 0.0]],     \"duration\": 400,     \"units\": \"mm/h\",     \"substances\": [       {         \"substance\": 1,         \"concentrations\": [[0, 0.0001], [3600, 0.0]]       },       {         \"substance\": 2,         \"concentrations\": [[0, 0.0002], [3600, 0.0]]         \"zone\": {           \"type\": \"Polygon\",           \"coordinates\": [             [               [5.1152647, 52.0929945],               [5.1152376, 52.0925619],               [5.1164597, 52.0924375],               [5.1165030, 52.0930215],               [5.1152647, 52.0929945]             ],           ]         }       }     ]   } ] ``` Substances can be applied to a zone within the rain event. The zone should be a GeoJSON polygon with coordinates in the EPSG-code specified in the `epsg_code`. If no `epsg_code` is specified, EPSG:4326 is assumed. The polygon will be intersected with the edges of nodes in the grid to determine which nodes receive the substance load. So nodes are either fully in or out of the polygon.  The `offset` of this file event will be added to each individual rain event offset in the uploaded file.  **Note**: the substance concentrations timesteps need to exactly match the rain event values timesteps
   */
  async simulationsEventsRainTimeseriesFileCreateRaw(
    requestParameters: SimulationsEventsRainTimeseriesFileCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<UploadBulkTimeseriesRainFile>> {
    const requestOptions = await this.simulationsEventsRainTimeseriesFileCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      UploadBulkTimeseriesRainFileFromJSON(jsonValue)
    );
  }

  /**
   * Endpoint for uploading a file with one or more timeseries rain events.  The format of the filename should be `<filename>.json`, e.g. `timeseries_rain.json`  Every leading and trailing spaces will be removed. Other spaces are converted to underscores and anything that is not an alphanumeric, dash, underscore, or dot will be removed as well.  The response provides a put_url which allows you to upload a file containing the rain events. These events should either be a constant- or a timeseries-rain, or a combination of both. See their respective endpoints for the required fields.  The uploaded file should be a JSON-file containing an array of rain events. Example of the content of such a file: ``` [   {     \"offset\": 100,     \"value\": 0.05,     \"duration\": 300,     \"units\": \"m3/s\",   },   {     \"offset\": 180,     \"interpolate\": false,     \"values\": [       [0.0, 0.0002],       [900.0, 0.0],       [1200.0, 0.0001],       [1620.0, 0.0]     ],     \"units\": \"m3/s\",   },   {     \"offset\": 200,     \"values\": [[0, 0.05], [3600, 0.0]],     \"duration\": 400,     \"units\": \"mm/h\",     \"substances\": [       {         \"substance\": 1,         \"concentrations\": [[0, 0.0001], [3600, 0.0]]       },       {         \"substance\": 2,         \"concentrations\": [[0, 0.0002], [3600, 0.0]]         \"zone\": {           \"type\": \"Polygon\",           \"coordinates\": [             [               [5.1152647, 52.0929945],               [5.1152376, 52.0925619],               [5.1164597, 52.0924375],               [5.1165030, 52.0930215],               [5.1152647, 52.0929945]             ],           ]         }       }     ]   } ] ``` Substances can be applied to a zone within the rain event. The zone should be a GeoJSON polygon with coordinates in the EPSG-code specified in the `epsg_code`. If no `epsg_code` is specified, EPSG:4326 is assumed. The polygon will be intersected with the edges of nodes in the grid to determine which nodes receive the substance load. So nodes are either fully in or out of the polygon.  The `offset` of this file event will be added to each individual rain event offset in the uploaded file.  **Note**: the substance concentrations timesteps need to exactly match the rain event values timesteps
   */
  async simulationsEventsRainTimeseriesFileCreate(
    requestParameters: SimulationsEventsRainTimeseriesFileCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<UploadBulkTimeseriesRainFile> {
    const response = await this.simulationsEventsRainTimeseriesFileCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsRainTimeseriesFileDelete without sending the request
   */
  async simulationsEventsRainTimeseriesFileDeleteRequestOpts(
    requestParameters: SimulationsEventsRainTimeseriesFileDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsRainTimeseriesFileDelete().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainTimeseriesFileDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/simulations/{simulation_pk}/events/rain/timeseries/file/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsRainTimeseriesFileDeleteRaw(
    requestParameters: SimulationsEventsRainTimeseriesFileDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsEventsRainTimeseriesFileDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * destroy resource only if the event has not yet been applied to the associated simulation
   */
  async simulationsEventsRainTimeseriesFileDelete(
    requestParameters: SimulationsEventsRainTimeseriesFileDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsEventsRainTimeseriesFileDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsEventsRainTimeseriesFileDownload without sending the request
   */
  async simulationsEventsRainTimeseriesFileDownloadRequestOpts(
    requestParameters: SimulationsEventsRainTimeseriesFileDownloadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsRainTimeseriesFileDownload().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainTimeseriesFileDownload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/simulations/{simulation_pk}/events/rain/timeseries/file/{id}/download/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Endpoint for downloading files.
   */
  async simulationsEventsRainTimeseriesFileDownloadRaw(
    requestParameters: SimulationsEventsRainTimeseriesFileDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Download>> {
    const requestOptions = await this.simulationsEventsRainTimeseriesFileDownloadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => DownloadFromJSON(jsonValue));
  }

  /**
   * Endpoint for downloading files.
   */
  async simulationsEventsRainTimeseriesFileDownload(
    requestParameters: SimulationsEventsRainTimeseriesFileDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Download> {
    const response = await this.simulationsEventsRainTimeseriesFileDownloadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsRainTimeseriesFileList without sending the request
   */
  async simulationsEventsRainTimeseriesFileListRequestOpts(
    requestParameters: SimulationsEventsRainTimeseriesFileListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainTimeseriesFileList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/simulations/{simulation_pk}/events/rain/timeseries/file/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * ViewMixin which adds an extra PUT-action \'processed\'.  Used by the api-workers event-validators to update the (asynchronous) validation results.
   */
  async simulationsEventsRainTimeseriesFileListRaw(
    requestParameters: SimulationsEventsRainTimeseriesFileListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedBulkTimeseriesRainList>> {
    const requestOptions = await this.simulationsEventsRainTimeseriesFileListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedBulkTimeseriesRainListFromJSON(jsonValue)
    );
  }

  /**
   * ViewMixin which adds an extra PUT-action \'processed\'.  Used by the api-workers event-validators to update the (asynchronous) validation results.
   */
  async simulationsEventsRainTimeseriesFileList(
    requestParameters: SimulationsEventsRainTimeseriesFileListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedBulkTimeseriesRainList> {
    const response = await this.simulationsEventsRainTimeseriesFileListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsRainTimeseriesFilePartialUpdate without sending the request
   */
  async simulationsEventsRainTimeseriesFilePartialUpdateRequestOpts(
    requestParameters: SimulationsEventsRainTimeseriesFilePartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsRainTimeseriesFilePartialUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainTimeseriesFilePartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsRainTimeseriesFilePartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/simulations/{simulation_pk}/events/rain/timeseries/file/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedBulkTimeseriesRainToJSON(requestParameters["data"]),
    };
  }

  /**
   * when the simulation has started only the duration parameter might be patched
   */
  async simulationsEventsRainTimeseriesFilePartialUpdateRaw(
    requestParameters: SimulationsEventsRainTimeseriesFilePartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PatchedResource>> {
    const requestOptions = await this.simulationsEventsRainTimeseriesFilePartialUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => PatchedResourceFromJSON(jsonValue));
  }

  /**
   * when the simulation has started only the duration parameter might be patched
   */
  async simulationsEventsRainTimeseriesFilePartialUpdate(
    requestParameters: SimulationsEventsRainTimeseriesFilePartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PatchedResource> {
    const response = await this.simulationsEventsRainTimeseriesFilePartialUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsRainTimeseriesFileProcessed without sending the request
   */
  async simulationsEventsRainTimeseriesFileProcessedRequestOpts(
    requestParameters: SimulationsEventsRainTimeseriesFileProcessedRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsRainTimeseriesFileProcessed().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainTimeseriesFileProcessed().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsRainTimeseriesFileProcessed().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/simulations/{simulation_pk}/events/rain/timeseries/file/{id}/processed/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: BaseEventStateToJSON(requestParameters["data"]),
    };
  }

  /**
   * ViewMixin which adds an extra PUT-action \'processed\'.  Used by the api-workers event-validators to update the (asynchronous) validation results.
   */
  async simulationsEventsRainTimeseriesFileProcessedRaw(
    requestParameters: SimulationsEventsRainTimeseriesFileProcessedRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsEventsRainTimeseriesFileProcessedRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * ViewMixin which adds an extra PUT-action \'processed\'.  Used by the api-workers event-validators to update the (asynchronous) validation results.
   */
  async simulationsEventsRainTimeseriesFileProcessed(
    requestParameters: SimulationsEventsRainTimeseriesFileProcessedRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsEventsRainTimeseriesFileProcessedRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsEventsRainTimeseriesFileRead without sending the request
   */
  async simulationsEventsRainTimeseriesFileReadRequestOpts(
    requestParameters: SimulationsEventsRainTimeseriesFileReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsRainTimeseriesFileRead().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainTimeseriesFileRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/simulations/{simulation_pk}/events/rain/timeseries/file/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * ViewMixin which adds an extra PUT-action \'processed\'.  Used by the api-workers event-validators to update the (asynchronous) validation results.
   */
  async simulationsEventsRainTimeseriesFileReadRaw(
    requestParameters: SimulationsEventsRainTimeseriesFileReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<BulkTimeseriesRain>> {
    const requestOptions = await this.simulationsEventsRainTimeseriesFileReadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      BulkTimeseriesRainFromJSON(jsonValue)
    );
  }

  /**
   * ViewMixin which adds an extra PUT-action \'processed\'.  Used by the api-workers event-validators to update the (asynchronous) validation results.
   */
  async simulationsEventsRainTimeseriesFileRead(
    requestParameters: SimulationsEventsRainTimeseriesFileReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<BulkTimeseriesRain> {
    const response = await this.simulationsEventsRainTimeseriesFileReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsEventsRainTimeseriesFileUpdate without sending the request
   */
  async simulationsEventsRainTimeseriesFileUpdateRequestOpts(
    requestParameters: SimulationsEventsRainTimeseriesFileUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsEventsRainTimeseriesFileUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsEventsRainTimeseriesFileUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsEventsRainTimeseriesFileUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/simulations/{simulation_pk}/events/rain/timeseries/file/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: BulkTimeseriesRainToJSON(requestParameters["data"]),
    };
  }

  /**
   * ViewMixin which adds an extra PUT-action \'processed\'.  Used by the api-workers event-validators to update the (asynchronous) validation results.
   */
  async simulationsEventsRainTimeseriesFileUpdateRaw(
    requestParameters: SimulationsEventsRainTimeseriesFileUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<BulkTimeseriesRain>> {
    const requestOptions = await this.simulationsEventsRainTimeseriesFileUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      BulkTimeseriesRainFromJSON(jsonValue)
    );
  }

  /**
   * ViewMixin which adds an extra PUT-action \'processed\'.  Used by the api-workers event-validators to update the (asynchronous) validation results.
   */
  async simulationsEventsRainTimeseriesFileUpdate(
    requestParameters: SimulationsEventsRainTimeseriesFileUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<BulkTimeseriesRain> {
    const response = await this.simulationsEventsRainTimeseriesFileUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitial1dSubstanceConcentrationsCreate without sending the request
   */
  async simulationsInitial1dSubstanceConcentrationsCreateRequestOpts(
    requestParameters: SimulationsInitial1dSubstanceConcentrationsCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitial1dSubstanceConcentrationsCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsInitial1dSubstanceConcentrationsCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/simulations/{simulation_pk}/initial/1d_substance_concentrations/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: OneDSubstanceConcentrationToJSON(requestParameters["data"]),
    };
  }

  /**
   * Start the simulation with a 1D (water quality) concentrations from a file. Applies the given values to the predefined nodes subset \"1D\" as described in the [threedigrid documentation] [ref]  [ref]: https://threedigrid.readthedocs.io/en/latest/api.html#subsets
   */
  async simulationsInitial1dSubstanceConcentrationsCreateRaw(
    requestParameters: SimulationsInitial1dSubstanceConcentrationsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<OneDSubstanceConcentration>> {
    const requestOptions = await this.simulationsInitial1dSubstanceConcentrationsCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      OneDSubstanceConcentrationFromJSON(jsonValue)
    );
  }

  /**
   * Start the simulation with a 1D (water quality) concentrations from a file. Applies the given values to the predefined nodes subset \"1D\" as described in the [threedigrid documentation] [ref]  [ref]: https://threedigrid.readthedocs.io/en/latest/api.html#subsets
   */
  async simulationsInitial1dSubstanceConcentrationsCreate(
    requestParameters: SimulationsInitial1dSubstanceConcentrationsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<OneDSubstanceConcentration> {
    const response = await this.simulationsInitial1dSubstanceConcentrationsCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitial1dSubstanceConcentrationsDelete without sending the request
   */
  async simulationsInitial1dSubstanceConcentrationsDeleteRequestOpts(
    requestParameters: SimulationsInitial1dSubstanceConcentrationsDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsInitial1dSubstanceConcentrationsDelete().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitial1dSubstanceConcentrationsDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/simulations/{simulation_pk}/initial/1d_substance_concentrations/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Initial 1D substance concentration
   */
  async simulationsInitial1dSubstanceConcentrationsDeleteRaw(
    requestParameters: SimulationsInitial1dSubstanceConcentrationsDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsInitial1dSubstanceConcentrationsDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Initial 1D substance concentration
   */
  async simulationsInitial1dSubstanceConcentrationsDelete(
    requestParameters: SimulationsInitial1dSubstanceConcentrationsDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsInitial1dSubstanceConcentrationsDeleteRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Creates request options for simulationsInitial1dSubstanceConcentrationsList without sending the request
   */
  async simulationsInitial1dSubstanceConcentrationsListRequestOpts(
    requestParameters: SimulationsInitial1dSubstanceConcentrationsListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitial1dSubstanceConcentrationsList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/simulations/{simulation_pk}/initial/1d_substance_concentrations/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Initial 1D substance concentration
   */
  async simulationsInitial1dSubstanceConcentrationsListRaw(
    requestParameters: SimulationsInitial1dSubstanceConcentrationsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedOneDSubstanceConcentrationList>> {
    const requestOptions = await this.simulationsInitial1dSubstanceConcentrationsListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedOneDSubstanceConcentrationListFromJSON(jsonValue)
    );
  }

  /**
   * Initial 1D substance concentration
   */
  async simulationsInitial1dSubstanceConcentrationsList(
    requestParameters: SimulationsInitial1dSubstanceConcentrationsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedOneDSubstanceConcentrationList> {
    const response = await this.simulationsInitial1dSubstanceConcentrationsListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitial1dSubstanceConcentrationsPartialUpdate without sending the request
   */
  async simulationsInitial1dSubstanceConcentrationsPartialUpdateRequestOpts(
    requestParameters: SimulationsInitial1dSubstanceConcentrationsPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsInitial1dSubstanceConcentrationsPartialUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitial1dSubstanceConcentrationsPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsInitial1dSubstanceConcentrationsPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/simulations/{simulation_pk}/initial/1d_substance_concentrations/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedOneDSubstanceConcentrationToJSON(requestParameters["data"]),
    };
  }

  /**
   * Initial 1D substance concentration
   */
  async simulationsInitial1dSubstanceConcentrationsPartialUpdateRaw(
    requestParameters: SimulationsInitial1dSubstanceConcentrationsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<OneDSubstanceConcentration>> {
    const requestOptions =
      await this.simulationsInitial1dSubstanceConcentrationsPartialUpdateRequestOpts(
        requestParameters
      );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      OneDSubstanceConcentrationFromJSON(jsonValue)
    );
  }

  /**
   * Initial 1D substance concentration
   */
  async simulationsInitial1dSubstanceConcentrationsPartialUpdate(
    requestParameters: SimulationsInitial1dSubstanceConcentrationsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<OneDSubstanceConcentration> {
    const response = await this.simulationsInitial1dSubstanceConcentrationsPartialUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitial1dSubstanceConcentrationsRead without sending the request
   */
  async simulationsInitial1dSubstanceConcentrationsReadRequestOpts(
    requestParameters: SimulationsInitial1dSubstanceConcentrationsReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsInitial1dSubstanceConcentrationsRead().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitial1dSubstanceConcentrationsRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/simulations/{simulation_pk}/initial/1d_substance_concentrations/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Initial 1D substance concentration
   */
  async simulationsInitial1dSubstanceConcentrationsReadRaw(
    requestParameters: SimulationsInitial1dSubstanceConcentrationsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<OneDSubstanceConcentration>> {
    const requestOptions = await this.simulationsInitial1dSubstanceConcentrationsReadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      OneDSubstanceConcentrationFromJSON(jsonValue)
    );
  }

  /**
   * Initial 1D substance concentration
   */
  async simulationsInitial1dSubstanceConcentrationsRead(
    requestParameters: SimulationsInitial1dSubstanceConcentrationsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<OneDSubstanceConcentration> {
    const response = await this.simulationsInitial1dSubstanceConcentrationsReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitial1dSubstanceConcentrationsUpdate without sending the request
   */
  async simulationsInitial1dSubstanceConcentrationsUpdateRequestOpts(
    requestParameters: SimulationsInitial1dSubstanceConcentrationsUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsInitial1dSubstanceConcentrationsUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitial1dSubstanceConcentrationsUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsInitial1dSubstanceConcentrationsUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/simulations/{simulation_pk}/initial/1d_substance_concentrations/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: OneDSubstanceConcentrationToJSON(requestParameters["data"]),
    };
  }

  /**
   * Initial 1D substance concentration
   */
  async simulationsInitial1dSubstanceConcentrationsUpdateRaw(
    requestParameters: SimulationsInitial1dSubstanceConcentrationsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<OneDSubstanceConcentration>> {
    const requestOptions = await this.simulationsInitial1dSubstanceConcentrationsUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      OneDSubstanceConcentrationFromJSON(jsonValue)
    );
  }

  /**
   * Initial 1D substance concentration
   */
  async simulationsInitial1dSubstanceConcentrationsUpdate(
    requestParameters: SimulationsInitial1dSubstanceConcentrationsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<OneDSubstanceConcentration> {
    const response = await this.simulationsInitial1dSubstanceConcentrationsUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitial2dSubstanceConcentrationsCreate without sending the request
   */
  async simulationsInitial2dSubstanceConcentrationsCreateRequestOpts(
    requestParameters: SimulationsInitial2dSubstanceConcentrationsCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitial2dSubstanceConcentrationsCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsInitial2dSubstanceConcentrationsCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/simulations/{simulation_pk}/initial/2d_substance_concentrations/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: TwoDSubstanceConcentrationToJSON(requestParameters["data"]),
    };
  }

  /**
   * Start the simulation with 2D (water quality) concentrations derived from the raster by using the aggregation method. Applies the resulting levels to the predefined nodes subset \"2D_OPEN_WATER\" as described in the [threedigrid documentation] [ref]  [ref]: https://threedigrid.readthedocs.io/en/latest/api.html#subsets
   */
  async simulationsInitial2dSubstanceConcentrationsCreateRaw(
    requestParameters: SimulationsInitial2dSubstanceConcentrationsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<TwoDSubstanceConcentration>> {
    const requestOptions = await this.simulationsInitial2dSubstanceConcentrationsCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      TwoDSubstanceConcentrationFromJSON(jsonValue)
    );
  }

  /**
   * Start the simulation with 2D (water quality) concentrations derived from the raster by using the aggregation method. Applies the resulting levels to the predefined nodes subset \"2D_OPEN_WATER\" as described in the [threedigrid documentation] [ref]  [ref]: https://threedigrid.readthedocs.io/en/latest/api.html#subsets
   */
  async simulationsInitial2dSubstanceConcentrationsCreate(
    requestParameters: SimulationsInitial2dSubstanceConcentrationsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<TwoDSubstanceConcentration> {
    const response = await this.simulationsInitial2dSubstanceConcentrationsCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitial2dSubstanceConcentrationsDelete without sending the request
   */
  async simulationsInitial2dSubstanceConcentrationsDeleteRequestOpts(
    requestParameters: SimulationsInitial2dSubstanceConcentrationsDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsInitial2dSubstanceConcentrationsDelete().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitial2dSubstanceConcentrationsDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/simulations/{simulation_pk}/initial/2d_substance_concentrations/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Initial 2D substance concentration
   */
  async simulationsInitial2dSubstanceConcentrationsDeleteRaw(
    requestParameters: SimulationsInitial2dSubstanceConcentrationsDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsInitial2dSubstanceConcentrationsDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Initial 2D substance concentration
   */
  async simulationsInitial2dSubstanceConcentrationsDelete(
    requestParameters: SimulationsInitial2dSubstanceConcentrationsDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsInitial2dSubstanceConcentrationsDeleteRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Creates request options for simulationsInitial2dSubstanceConcentrationsList without sending the request
   */
  async simulationsInitial2dSubstanceConcentrationsListRequestOpts(
    requestParameters: SimulationsInitial2dSubstanceConcentrationsListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitial2dSubstanceConcentrationsList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/simulations/{simulation_pk}/initial/2d_substance_concentrations/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Initial 2D substance concentration
   */
  async simulationsInitial2dSubstanceConcentrationsListRaw(
    requestParameters: SimulationsInitial2dSubstanceConcentrationsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedTwoDSubstanceConcentrationList>> {
    const requestOptions = await this.simulationsInitial2dSubstanceConcentrationsListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedTwoDSubstanceConcentrationListFromJSON(jsonValue)
    );
  }

  /**
   * Initial 2D substance concentration
   */
  async simulationsInitial2dSubstanceConcentrationsList(
    requestParameters: SimulationsInitial2dSubstanceConcentrationsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedTwoDSubstanceConcentrationList> {
    const response = await this.simulationsInitial2dSubstanceConcentrationsListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitial2dSubstanceConcentrationsPartialUpdate without sending the request
   */
  async simulationsInitial2dSubstanceConcentrationsPartialUpdateRequestOpts(
    requestParameters: SimulationsInitial2dSubstanceConcentrationsPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsInitial2dSubstanceConcentrationsPartialUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitial2dSubstanceConcentrationsPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsInitial2dSubstanceConcentrationsPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/simulations/{simulation_pk}/initial/2d_substance_concentrations/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedTwoDSubstanceConcentrationToJSON(requestParameters["data"]),
    };
  }

  /**
   * Initial 2D substance concentration
   */
  async simulationsInitial2dSubstanceConcentrationsPartialUpdateRaw(
    requestParameters: SimulationsInitial2dSubstanceConcentrationsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<TwoDSubstanceConcentration>> {
    const requestOptions =
      await this.simulationsInitial2dSubstanceConcentrationsPartialUpdateRequestOpts(
        requestParameters
      );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      TwoDSubstanceConcentrationFromJSON(jsonValue)
    );
  }

  /**
   * Initial 2D substance concentration
   */
  async simulationsInitial2dSubstanceConcentrationsPartialUpdate(
    requestParameters: SimulationsInitial2dSubstanceConcentrationsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<TwoDSubstanceConcentration> {
    const response = await this.simulationsInitial2dSubstanceConcentrationsPartialUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitial2dSubstanceConcentrationsRead without sending the request
   */
  async simulationsInitial2dSubstanceConcentrationsReadRequestOpts(
    requestParameters: SimulationsInitial2dSubstanceConcentrationsReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsInitial2dSubstanceConcentrationsRead().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitial2dSubstanceConcentrationsRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/simulations/{simulation_pk}/initial/2d_substance_concentrations/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Initial 2D substance concentration
   */
  async simulationsInitial2dSubstanceConcentrationsReadRaw(
    requestParameters: SimulationsInitial2dSubstanceConcentrationsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<TwoDSubstanceConcentration>> {
    const requestOptions = await this.simulationsInitial2dSubstanceConcentrationsReadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      TwoDSubstanceConcentrationFromJSON(jsonValue)
    );
  }

  /**
   * Initial 2D substance concentration
   */
  async simulationsInitial2dSubstanceConcentrationsRead(
    requestParameters: SimulationsInitial2dSubstanceConcentrationsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<TwoDSubstanceConcentration> {
    const response = await this.simulationsInitial2dSubstanceConcentrationsReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitial2dSubstanceConcentrationsUpdate without sending the request
   */
  async simulationsInitial2dSubstanceConcentrationsUpdateRequestOpts(
    requestParameters: SimulationsInitial2dSubstanceConcentrationsUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsInitial2dSubstanceConcentrationsUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitial2dSubstanceConcentrationsUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsInitial2dSubstanceConcentrationsUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/simulations/{simulation_pk}/initial/2d_substance_concentrations/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: TwoDSubstanceConcentrationToJSON(requestParameters["data"]),
    };
  }

  /**
   * Initial 2D substance concentration
   */
  async simulationsInitial2dSubstanceConcentrationsUpdateRaw(
    requestParameters: SimulationsInitial2dSubstanceConcentrationsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<TwoDSubstanceConcentration>> {
    const requestOptions = await this.simulationsInitial2dSubstanceConcentrationsUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      TwoDSubstanceConcentrationFromJSON(jsonValue)
    );
  }

  /**
   * Initial 2D substance concentration
   */
  async simulationsInitial2dSubstanceConcentrationsUpdate(
    requestParameters: SimulationsInitial2dSubstanceConcentrationsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<TwoDSubstanceConcentration> {
    const response = await this.simulationsInitial2dSubstanceConcentrationsUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitialGroundwaterSubstanceConcentrationsCreate without sending the request
   */
  async simulationsInitialGroundwaterSubstanceConcentrationsCreateRequestOpts(
    requestParameters: SimulationsInitialGroundwaterSubstanceConcentrationsCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitialGroundwaterSubstanceConcentrationsCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsInitialGroundwaterSubstanceConcentrationsCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/simulations/{simulation_pk}/initial/groundwater_substance_concentrations/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: GroundWaterSubstanceConcentrationToJSON(requestParameters["data"]),
    };
  }

  /**
   * Start the simulation with groundwater (water quality) concentrations derived from the raster by using the aggregation method. Applies the resulting levels to the predefined nodes subset \"2D_GROUND_WATER\" as described in the [threedigrid documentation] [ref]  [ref]: https://threedigrid.readthedocs.io/en/latest/api.html#subsets
   */
  async simulationsInitialGroundwaterSubstanceConcentrationsCreateRaw(
    requestParameters: SimulationsInitialGroundwaterSubstanceConcentrationsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GroundWaterSubstanceConcentration>> {
    const requestOptions =
      await this.simulationsInitialGroundwaterSubstanceConcentrationsCreateRequestOpts(
        requestParameters
      );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GroundWaterSubstanceConcentrationFromJSON(jsonValue)
    );
  }

  /**
   * Start the simulation with groundwater (water quality) concentrations derived from the raster by using the aggregation method. Applies the resulting levels to the predefined nodes subset \"2D_GROUND_WATER\" as described in the [threedigrid documentation] [ref]  [ref]: https://threedigrid.readthedocs.io/en/latest/api.html#subsets
   */
  async simulationsInitialGroundwaterSubstanceConcentrationsCreate(
    requestParameters: SimulationsInitialGroundwaterSubstanceConcentrationsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GroundWaterSubstanceConcentration> {
    const response = await this.simulationsInitialGroundwaterSubstanceConcentrationsCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitialGroundwaterSubstanceConcentrationsDelete without sending the request
   */
  async simulationsInitialGroundwaterSubstanceConcentrationsDeleteRequestOpts(
    requestParameters: SimulationsInitialGroundwaterSubstanceConcentrationsDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsInitialGroundwaterSubstanceConcentrationsDelete().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitialGroundwaterSubstanceConcentrationsDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/simulations/{simulation_pk}/initial/groundwater_substance_concentrations/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Initial 2D substance concentration
   */
  async simulationsInitialGroundwaterSubstanceConcentrationsDeleteRaw(
    requestParameters: SimulationsInitialGroundwaterSubstanceConcentrationsDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions =
      await this.simulationsInitialGroundwaterSubstanceConcentrationsDeleteRequestOpts(
        requestParameters
      );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Initial 2D substance concentration
   */
  async simulationsInitialGroundwaterSubstanceConcentrationsDelete(
    requestParameters: SimulationsInitialGroundwaterSubstanceConcentrationsDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsInitialGroundwaterSubstanceConcentrationsDeleteRaw(
      requestParameters,
      initOverrides
    );
  }

  /**
   * Creates request options for simulationsInitialGroundwaterSubstanceConcentrationsList without sending the request
   */
  async simulationsInitialGroundwaterSubstanceConcentrationsListRequestOpts(
    requestParameters: SimulationsInitialGroundwaterSubstanceConcentrationsListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitialGroundwaterSubstanceConcentrationsList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/simulations/{simulation_pk}/initial/groundwater_substance_concentrations/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Initial 2D substance concentration
   */
  async simulationsInitialGroundwaterSubstanceConcentrationsListRaw(
    requestParameters: SimulationsInitialGroundwaterSubstanceConcentrationsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedGroundWaterSubstanceConcentrationList>> {
    const requestOptions =
      await this.simulationsInitialGroundwaterSubstanceConcentrationsListRequestOpts(
        requestParameters
      );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedGroundWaterSubstanceConcentrationListFromJSON(jsonValue)
    );
  }

  /**
   * Initial 2D substance concentration
   */
  async simulationsInitialGroundwaterSubstanceConcentrationsList(
    requestParameters: SimulationsInitialGroundwaterSubstanceConcentrationsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedGroundWaterSubstanceConcentrationList> {
    const response = await this.simulationsInitialGroundwaterSubstanceConcentrationsListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitialGroundwaterSubstanceConcentrationsPartialUpdate without sending the request
   */
  async simulationsInitialGroundwaterSubstanceConcentrationsPartialUpdateRequestOpts(
    requestParameters: SimulationsInitialGroundwaterSubstanceConcentrationsPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsInitialGroundwaterSubstanceConcentrationsPartialUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitialGroundwaterSubstanceConcentrationsPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsInitialGroundwaterSubstanceConcentrationsPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/simulations/{simulation_pk}/initial/groundwater_substance_concentrations/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedGroundWaterSubstanceConcentrationToJSON(requestParameters["data"]),
    };
  }

  /**
   * Initial 2D substance concentration
   */
  async simulationsInitialGroundwaterSubstanceConcentrationsPartialUpdateRaw(
    requestParameters: SimulationsInitialGroundwaterSubstanceConcentrationsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GroundWaterSubstanceConcentration>> {
    const requestOptions =
      await this.simulationsInitialGroundwaterSubstanceConcentrationsPartialUpdateRequestOpts(
        requestParameters
      );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GroundWaterSubstanceConcentrationFromJSON(jsonValue)
    );
  }

  /**
   * Initial 2D substance concentration
   */
  async simulationsInitialGroundwaterSubstanceConcentrationsPartialUpdate(
    requestParameters: SimulationsInitialGroundwaterSubstanceConcentrationsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GroundWaterSubstanceConcentration> {
    const response =
      await this.simulationsInitialGroundwaterSubstanceConcentrationsPartialUpdateRaw(
        requestParameters,
        initOverrides
      );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitialGroundwaterSubstanceConcentrationsRead without sending the request
   */
  async simulationsInitialGroundwaterSubstanceConcentrationsReadRequestOpts(
    requestParameters: SimulationsInitialGroundwaterSubstanceConcentrationsReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsInitialGroundwaterSubstanceConcentrationsRead().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitialGroundwaterSubstanceConcentrationsRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/simulations/{simulation_pk}/initial/groundwater_substance_concentrations/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Initial 2D substance concentration
   */
  async simulationsInitialGroundwaterSubstanceConcentrationsReadRaw(
    requestParameters: SimulationsInitialGroundwaterSubstanceConcentrationsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GroundWaterSubstanceConcentration>> {
    const requestOptions =
      await this.simulationsInitialGroundwaterSubstanceConcentrationsReadRequestOpts(
        requestParameters
      );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GroundWaterSubstanceConcentrationFromJSON(jsonValue)
    );
  }

  /**
   * Initial 2D substance concentration
   */
  async simulationsInitialGroundwaterSubstanceConcentrationsRead(
    requestParameters: SimulationsInitialGroundwaterSubstanceConcentrationsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GroundWaterSubstanceConcentration> {
    const response = await this.simulationsInitialGroundwaterSubstanceConcentrationsReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsInitialGroundwaterSubstanceConcentrationsUpdate without sending the request
   */
  async simulationsInitialGroundwaterSubstanceConcentrationsUpdateRequestOpts(
    requestParameters: SimulationsInitialGroundwaterSubstanceConcentrationsUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsInitialGroundwaterSubstanceConcentrationsUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsInitialGroundwaterSubstanceConcentrationsUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsInitialGroundwaterSubstanceConcentrationsUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/simulations/{simulation_pk}/initial/groundwater_substance_concentrations/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: GroundWaterSubstanceConcentrationToJSON(requestParameters["data"]),
    };
  }

  /**
   * Initial 2D substance concentration
   */
  async simulationsInitialGroundwaterSubstanceConcentrationsUpdateRaw(
    requestParameters: SimulationsInitialGroundwaterSubstanceConcentrationsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GroundWaterSubstanceConcentration>> {
    const requestOptions =
      await this.simulationsInitialGroundwaterSubstanceConcentrationsUpdateRequestOpts(
        requestParameters
      );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GroundWaterSubstanceConcentrationFromJSON(jsonValue)
    );
  }

  /**
   * Initial 2D substance concentration
   */
  async simulationsInitialGroundwaterSubstanceConcentrationsUpdate(
    requestParameters: SimulationsInitialGroundwaterSubstanceConcentrationsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GroundWaterSubstanceConcentration> {
    const response = await this.simulationsInitialGroundwaterSubstanceConcentrationsUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsSubstancesCreate without sending the request
   */
  async simulationsSubstancesCreateRequestOpts(
    requestParameters: SimulationsSubstancesCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsSubstancesCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsSubstancesCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/simulations/{simulation_pk}/substances/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: SubstanceToJSON(requestParameters["data"]),
    };
  }

  /**
   * Add substance to simulation substances set.
   */
  async simulationsSubstancesCreateRaw(
    requestParameters: SimulationsSubstancesCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Substance>> {
    const requestOptions = await this.simulationsSubstancesCreateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => SubstanceFromJSON(jsonValue));
  }

  /**
   * Add substance to simulation substances set.
   */
  async simulationsSubstancesCreate(
    requestParameters: SimulationsSubstancesCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Substance> {
    const response = await this.simulationsSubstancesCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for simulationsSubstancesDelete without sending the request
   */
  async simulationsSubstancesDeleteRequestOpts(
    requestParameters: SimulationsSubstancesDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsSubstancesDelete().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsSubstancesDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/simulations/{simulation_pk}/substances/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Water quality substances
   */
  async simulationsSubstancesDeleteRaw(
    requestParameters: SimulationsSubstancesDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.simulationsSubstancesDeleteRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Water quality substances
   */
  async simulationsSubstancesDelete(
    requestParameters: SimulationsSubstancesDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.simulationsSubstancesDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for simulationsSubstancesList without sending the request
   */
  async simulationsSubstancesListRequestOpts(
    requestParameters: SimulationsSubstancesListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsSubstancesList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/simulations/{simulation_pk}/substances/`;
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Water quality substances
   */
  async simulationsSubstancesListRaw(
    requestParameters: SimulationsSubstancesListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedSubstanceList>> {
    const requestOptions = await this.simulationsSubstancesListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedSubstanceListFromJSON(jsonValue)
    );
  }

  /**
   * Water quality substances
   */
  async simulationsSubstancesList(
    requestParameters: SimulationsSubstancesListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedSubstanceList> {
    const response = await this.simulationsSubstancesListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for simulationsSubstancesPartialUpdate without sending the request
   */
  async simulationsSubstancesPartialUpdateRequestOpts(
    requestParameters: SimulationsSubstancesPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsSubstancesPartialUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsSubstancesPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsSubstancesPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/simulations/{simulation_pk}/substances/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedSubstanceToJSON(requestParameters["data"]),
    };
  }

  /**
   * Water quality substances
   */
  async simulationsSubstancesPartialUpdateRaw(
    requestParameters: SimulationsSubstancesPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Substance>> {
    const requestOptions = await this.simulationsSubstancesPartialUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => SubstanceFromJSON(jsonValue));
  }

  /**
   * Water quality substances
   */
  async simulationsSubstancesPartialUpdate(
    requestParameters: SimulationsSubstancesPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Substance> {
    const response = await this.simulationsSubstancesPartialUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for simulationsSubstancesRead without sending the request
   */
  async simulationsSubstancesReadRequestOpts(
    requestParameters: SimulationsSubstancesReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsSubstancesRead().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsSubstancesRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/simulations/{simulation_pk}/substances/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Water quality substances
   */
  async simulationsSubstancesReadRaw(
    requestParameters: SimulationsSubstancesReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Substance>> {
    const requestOptions = await this.simulationsSubstancesReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => SubstanceFromJSON(jsonValue));
  }

  /**
   * Water quality substances
   */
  async simulationsSubstancesRead(
    requestParameters: SimulationsSubstancesReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Substance> {
    const response = await this.simulationsSubstancesReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for simulationsSubstancesUpdate without sending the request
   */
  async simulationsSubstancesUpdateRequestOpts(
    requestParameters: SimulationsSubstancesUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling simulationsSubstancesUpdate().'
      );
    }

    if (requestParameters["simulationPk"] == null) {
      throw new runtime.RequiredError(
        "simulationPk",
        'Required parameter "simulationPk" was null or undefined when calling simulationsSubstancesUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling simulationsSubstancesUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/simulations/{simulation_pk}/substances/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{simulation_pk}",
      encodeURIComponent(String(requestParameters["simulationPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: SubstanceToJSON(requestParameters["data"]),
    };
  }

  /**
   * Water quality substances
   */
  async simulationsSubstancesUpdateRaw(
    requestParameters: SimulationsSubstancesUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Substance>> {
    const requestOptions = await this.simulationsSubstancesUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => SubstanceFromJSON(jsonValue));
  }

  /**
   * Water quality substances
   */
  async simulationsSubstancesUpdate(
    requestParameters: SimulationsSubstancesUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Substance> {
    const response = await this.simulationsSubstancesUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for statusCurrentVersion without sending the request
   */
  async statusCurrentVersionRequestOpts(): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/status/current-version/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   */
  async statusCurrentVersionRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CurrentVersion>> {
    const requestOptions = await this.statusCurrentVersionRequestOpts();
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => CurrentVersionFromJSON(jsonValue));
  }

  /**
   */
  async statusCurrentVersion(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CurrentVersion> {
    const response = await this.statusCurrentVersionRaw(initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for statusList without sending the request
   */
  async statusListRequestOpts(): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/status/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   */
  async statusListRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Status>> {
    const requestOptions = await this.statusListRequestOpts();
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => StatusFromJSON(jsonValue));
  }

  /**
   */
  async statusList(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Status> {
    const response = await this.statusListRaw(initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsInitialConcentrationsCreate without sending the request
   */
  async threedimodelsInitialConcentrationsCreateRequestOpts(
    requestParameters: ThreedimodelsInitialConcentrationsCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["threedimodelPk"] == null) {
      throw new runtime.RequiredError(
        "threedimodelPk",
        'Required parameter "threedimodelPk" was null or undefined when calling threedimodelsInitialConcentrationsCreate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling threedimodelsInitialConcentrationsCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/threedimodels/{threedimodel_pk}/initial_concentrations/`;
    urlPath = urlPath.replace(
      "{threedimodel_pk}",
      encodeURIComponent(String(requestParameters["threedimodelPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: InitialConcentrationToJSON(requestParameters["data"]),
    };
  }

  /**
   * Add new initial concentrations  ### Adding (extra) 1D initial concentrations Extra 1D initial concentrations can be added by posting:  {\"dimension\": \"one_d\"}  Using the \'id\' value from the response, a JSON file needs to be uploaded via the PUT_URL retrieved from `initial_concentrations/{id}/upload/` in the following JSON format:  Python code:      import json     file_contents = json.dumps({         \"node_ids\": [node_id_1, node_id2, ....],         \"values\" : [value_for_node_id_1, value_for_node_id_2, ...]     })      # Notes:     # - Omitted values are considered dry.     # - `node_ids` need to be sorted and unique     # - Make sure that the positions of the node_id\'s and values match.  ### Adding (extra) 2D initial substance concentrations 2D initial concentrations can be added by uploading an \'initial_concentration_file\' Geotiff raster via `rasters/{id}/upload/` . This automatically triggers the creation of a 2D initial concentration. The source raster is linked as \'source_raster\'. The values in the  `source_raster` are aggregated per node using max, min and mean operators. The resulting values are stored in a file linked under `file`.
   */
  async threedimodelsInitialConcentrationsCreateRaw(
    requestParameters: ThreedimodelsInitialConcentrationsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<InitialConcentration>> {
    const requestOptions = await this.threedimodelsInitialConcentrationsCreateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      InitialConcentrationFromJSON(jsonValue)
    );
  }

  /**
   * Add new initial concentrations  ### Adding (extra) 1D initial concentrations Extra 1D initial concentrations can be added by posting:  {\"dimension\": \"one_d\"}  Using the \'id\' value from the response, a JSON file needs to be uploaded via the PUT_URL retrieved from `initial_concentrations/{id}/upload/` in the following JSON format:  Python code:      import json     file_contents = json.dumps({         \"node_ids\": [node_id_1, node_id2, ....],         \"values\" : [value_for_node_id_1, value_for_node_id_2, ...]     })      # Notes:     # - Omitted values are considered dry.     # - `node_ids` need to be sorted and unique     # - Make sure that the positions of the node_id\'s and values match.  ### Adding (extra) 2D initial substance concentrations 2D initial concentrations can be added by uploading an \'initial_concentration_file\' Geotiff raster via `rasters/{id}/upload/` . This automatically triggers the creation of a 2D initial concentration. The source raster is linked as \'source_raster\'. The values in the  `source_raster` are aggregated per node using max, min and mean operators. The resulting values are stored in a file linked under `file`.
   */
  async threedimodelsInitialConcentrationsCreate(
    requestParameters: ThreedimodelsInitialConcentrationsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<InitialConcentration> {
    const response = await this.threedimodelsInitialConcentrationsCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsInitialConcentrationsDelete without sending the request
   */
  async threedimodelsInitialConcentrationsDeleteRequestOpts(
    requestParameters: ThreedimodelsInitialConcentrationsDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsInitialConcentrationsDelete().'
      );
    }

    if (requestParameters["threedimodelPk"] == null) {
      throw new runtime.RequiredError(
        "threedimodelPk",
        'Required parameter "threedimodelPk" was null or undefined when calling threedimodelsInitialConcentrationsDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/threedimodels/{threedimodel_pk}/initial_concentrations/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{threedimodel_pk}",
      encodeURIComponent(String(requestParameters["threedimodelPk"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Delete initial substance concentration  Note: Initial substance concentrations can only be deleted when not in use in any simulation.
   */
  async threedimodelsInitialConcentrationsDeleteRaw(
    requestParameters: ThreedimodelsInitialConcentrationsDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.threedimodelsInitialConcentrationsDeleteRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Delete initial substance concentration  Note: Initial substance concentrations can only be deleted when not in use in any simulation.
   */
  async threedimodelsInitialConcentrationsDelete(
    requestParameters: ThreedimodelsInitialConcentrationsDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.threedimodelsInitialConcentrationsDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for threedimodelsInitialConcentrationsDownload without sending the request
   */
  async threedimodelsInitialConcentrationsDownloadRequestOpts(
    requestParameters: ThreedimodelsInitialConcentrationsDownloadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsInitialConcentrationsDownload().'
      );
    }

    if (requestParameters["threedimodelPk"] == null) {
      throw new runtime.RequiredError(
        "threedimodelPk",
        'Required parameter "threedimodelPk" was null or undefined when calling threedimodelsInitialConcentrationsDownload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/threedimodels/{threedimodel_pk}/initial_concentrations/{id}/download/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{threedimodel_pk}",
      encodeURIComponent(String(requestParameters["threedimodelPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Endpoint for downloading files.
   */
  async threedimodelsInitialConcentrationsDownloadRaw(
    requestParameters: ThreedimodelsInitialConcentrationsDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Download>> {
    const requestOptions = await this.threedimodelsInitialConcentrationsDownloadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => DownloadFromJSON(jsonValue));
  }

  /**
   * Endpoint for downloading files.
   */
  async threedimodelsInitialConcentrationsDownload(
    requestParameters: ThreedimodelsInitialConcentrationsDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Download> {
    const response = await this.threedimodelsInitialConcentrationsDownloadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsInitialConcentrationsList without sending the request
   */
  async threedimodelsInitialConcentrationsListRequestOpts(
    requestParameters: ThreedimodelsInitialConcentrationsListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["threedimodelPk"] == null) {
      throw new runtime.RequiredError(
        "threedimodelPk",
        'Required parameter "threedimodelPk" was null or undefined when calling threedimodelsInitialConcentrationsList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/threedimodels/{threedimodel_pk}/initial_concentrations/`;
    urlPath = urlPath.replace(
      "{threedimodel_pk}",
      encodeURIComponent(String(requestParameters["threedimodelPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * ## Description Initial substance concentrations on threedimodels can be used in a simulation to specify the initial substance concentration on the 1D and/or 2D domain.
   */
  async threedimodelsInitialConcentrationsListRaw(
    requestParameters: ThreedimodelsInitialConcentrationsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PaginatedInitialConcentrationList>> {
    const requestOptions = await this.threedimodelsInitialConcentrationsListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaginatedInitialConcentrationListFromJSON(jsonValue)
    );
  }

  /**
   * ## Description Initial substance concentrations on threedimodels can be used in a simulation to specify the initial substance concentration on the 1D and/or 2D domain.
   */
  async threedimodelsInitialConcentrationsList(
    requestParameters: ThreedimodelsInitialConcentrationsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PaginatedInitialConcentrationList> {
    const response = await this.threedimodelsInitialConcentrationsListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsInitialConcentrationsPartialUpdate without sending the request
   */
  async threedimodelsInitialConcentrationsPartialUpdateRequestOpts(
    requestParameters: ThreedimodelsInitialConcentrationsPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsInitialConcentrationsPartialUpdate().'
      );
    }

    if (requestParameters["threedimodelPk"] == null) {
      throw new runtime.RequiredError(
        "threedimodelPk",
        'Required parameter "threedimodelPk" was null or undefined when calling threedimodelsInitialConcentrationsPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling threedimodelsInitialConcentrationsPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/threedimodels/{threedimodel_pk}/initial_concentrations/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{threedimodel_pk}",
      encodeURIComponent(String(requestParameters["threedimodelPk"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: PatchedInitialConcentrationToJSON(requestParameters["data"]),
    };
  }

  /**
   * ## Description Initial substance concentrations on threedimodels can be used in a simulation to specify the initial substance concentration on the 1D and/or 2D domain.
   */
  async threedimodelsInitialConcentrationsPartialUpdateRaw(
    requestParameters: ThreedimodelsInitialConcentrationsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<InitialConcentration>> {
    const requestOptions = await this.threedimodelsInitialConcentrationsPartialUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      InitialConcentrationFromJSON(jsonValue)
    );
  }

  /**
   * ## Description Initial substance concentrations on threedimodels can be used in a simulation to specify the initial substance concentration on the 1D and/or 2D domain.
   */
  async threedimodelsInitialConcentrationsPartialUpdate(
    requestParameters: ThreedimodelsInitialConcentrationsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<InitialConcentration> {
    const response = await this.threedimodelsInitialConcentrationsPartialUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsInitialConcentrationsProcessed without sending the request
   */
  async threedimodelsInitialConcentrationsProcessedRequestOpts(
    requestParameters: ThreedimodelsInitialConcentrationsProcessedRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsInitialConcentrationsProcessed().'
      );
    }

    if (requestParameters["threedimodelPk"] == null) {
      throw new runtime.RequiredError(
        "threedimodelPk",
        'Required parameter "threedimodelPk" was null or undefined when calling threedimodelsInitialConcentrationsProcessed().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling threedimodelsInitialConcentrationsProcessed().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/threedimodels/{threedimodel_pk}/initial_concentrations/{id}/processed/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{threedimodel_pk}",
      encodeURIComponent(String(requestParameters["threedimodelPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: BaseEventStateToJSON(requestParameters["data"]),
    };
  }

  /**
   * ## Description Initial substance concentrations on threedimodels can be used in a simulation to specify the initial substance concentration on the 1D and/or 2D domain.
   */
  async threedimodelsInitialConcentrationsProcessedRaw(
    requestParameters: ThreedimodelsInitialConcentrationsProcessedRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.threedimodelsInitialConcentrationsProcessedRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * ## Description Initial substance concentrations on threedimodels can be used in a simulation to specify the initial substance concentration on the 1D and/or 2D domain.
   */
  async threedimodelsInitialConcentrationsProcessed(
    requestParameters: ThreedimodelsInitialConcentrationsProcessedRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.threedimodelsInitialConcentrationsProcessedRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for threedimodelsInitialConcentrationsRead without sending the request
   */
  async threedimodelsInitialConcentrationsReadRequestOpts(
    requestParameters: ThreedimodelsInitialConcentrationsReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsInitialConcentrationsRead().'
      );
    }

    if (requestParameters["threedimodelPk"] == null) {
      throw new runtime.RequiredError(
        "threedimodelPk",
        'Required parameter "threedimodelPk" was null or undefined when calling threedimodelsInitialConcentrationsRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/threedimodels/{threedimodel_pk}/initial_concentrations/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{threedimodel_pk}",
      encodeURIComponent(String(requestParameters["threedimodelPk"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * ## Description Initial substance concentrations on threedimodels can be used in a simulation to specify the initial substance concentration on the 1D and/or 2D domain.
   */
  async threedimodelsInitialConcentrationsReadRaw(
    requestParameters: ThreedimodelsInitialConcentrationsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<InitialConcentration>> {
    const requestOptions = await this.threedimodelsInitialConcentrationsReadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      InitialConcentrationFromJSON(jsonValue)
    );
  }

  /**
   * ## Description Initial substance concentrations on threedimodels can be used in a simulation to specify the initial substance concentration on the 1D and/or 2D domain.
   */
  async threedimodelsInitialConcentrationsRead(
    requestParameters: ThreedimodelsInitialConcentrationsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<InitialConcentration> {
    const response = await this.threedimodelsInitialConcentrationsReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsInitialConcentrationsUpdate without sending the request
   */
  async threedimodelsInitialConcentrationsUpdateRequestOpts(
    requestParameters: ThreedimodelsInitialConcentrationsUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsInitialConcentrationsUpdate().'
      );
    }

    if (requestParameters["threedimodelPk"] == null) {
      throw new runtime.RequiredError(
        "threedimodelPk",
        'Required parameter "threedimodelPk" was null or undefined when calling threedimodelsInitialConcentrationsUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling threedimodelsInitialConcentrationsUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/threedimodels/{threedimodel_pk}/initial_concentrations/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{threedimodel_pk}",
      encodeURIComponent(String(requestParameters["threedimodelPk"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: InitialConcentrationToJSON(requestParameters["data"]),
    };
  }

  /**
   * ## Description Initial substance concentrations on threedimodels can be used in a simulation to specify the initial substance concentration on the 1D and/or 2D domain.
   */
  async threedimodelsInitialConcentrationsUpdateRaw(
    requestParameters: ThreedimodelsInitialConcentrationsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<InitialConcentration>> {
    const requestOptions = await this.threedimodelsInitialConcentrationsUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      InitialConcentrationFromJSON(jsonValue)
    );
  }

  /**
   * ## Description Initial substance concentrations on threedimodels can be used in a simulation to specify the initial substance concentration on the 1D and/or 2D domain.
   */
  async threedimodelsInitialConcentrationsUpdate(
    requestParameters: ThreedimodelsInitialConcentrationsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<InitialConcentration> {
    const response = await this.threedimodelsInitialConcentrationsUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for threedimodelsInitialConcentrationsUpload without sending the request
   */
  async threedimodelsInitialConcentrationsUploadRequestOpts(
    requestParameters: ThreedimodelsInitialConcentrationsUploadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling threedimodelsInitialConcentrationsUpload().'
      );
    }

    if (requestParameters["threedimodelPk"] == null) {
      throw new runtime.RequiredError(
        "threedimodelPk",
        'Required parameter "threedimodelPk" was null or undefined when calling threedimodelsInitialConcentrationsUpload().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling threedimodelsInitialConcentrationsUpload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("OAuth2Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    let urlPath = `/v3-beta/threedimodels/{threedimodel_pk}/initial_concentrations/{id}/upload/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));
    urlPath = urlPath.replace(
      "{threedimodel_pk}",
      encodeURIComponent(String(requestParameters["threedimodelPk"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: UploadToJSON(requestParameters["data"]),
    };
  }

  /**
   * Endpoint for uploading an initial substance concentration file, see the POST endpoint for documentation about the file format.
   */
  async threedimodelsInitialConcentrationsUploadRaw(
    requestParameters: ThreedimodelsInitialConcentrationsUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Upload>> {
    const requestOptions = await this.threedimodelsInitialConcentrationsUploadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => UploadFromJSON(jsonValue));
  }

  /**
   * Endpoint for uploading an initial substance concentration file, see the POST endpoint for documentation about the file format.
   */
  async threedimodelsInitialConcentrationsUpload(
    requestParameters: ThreedimodelsInitialConcentrationsUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Upload> {
    const response = await this.threedimodelsInitialConcentrationsUploadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }
}
